import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, watch } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'  
  import store from '@/store'    
  import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'  

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageTimeLine',
  props: {
    coverageIteration: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {
    coverageIteration:AloDbCoverageIteration,
    uiid:string};

  
  const isPlaying = ref(false)
  const _currentValue = ref(-1)
  
  const currentValue = computed({
    get: () => _currentValue.value == -1?(allYos.value.length > 0?allYos.value.length-1:0): _currentValue.value,
    set: (val) => {
      _currentValue.value = val
    }
  })  

  
    
  const coverageIterationState = computed(()=> store.myGetters.coverageIterationStateByUiid(props.uiid))  
  const gliderKeys = computed(()=>Object.keys(props.coverageIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))

  const timelineIndex = computed(()=> coverageIterationState.value.timelineIndex)

  const gliderTimelineIndex = computed(()=> gliderKeys.value.map(glider => store.myGetters.coverageIterationMissionUiStateByUiid(buildCoverageIterationMissionUiStateId(props.uiid,glider)).timelineIndex))

  const currentDate = computed(()=> allYos.value?.[currentValue.value]?.date)

  const canUpdateYoIndex = ref(true)

  function changeValue(newValue:number){
    coverageIterationState.value.timelineIndex = newValue
  }
  

  const allYos = computed(()=> 
    gliderKeys.value.reduce((acc, key) => {
      const yos = props.coverageIteration?.resultAloMission?.[key]?.yoArray?.map((y,idx) => ({glider:key,idx,date:y?.yoGpsDatTime,isUnderWater:y?.isUnderWater,cycle:y?.yosCycle})) ?? [] 
      let lastDate = yos?.at(0)?.date!
      yos?.forEach(y => {        
        if(y.date.toString() =='Invalid Date') {           
          y.date = new Date(lastDate.getTime() + 1)
          lastDate = y.date
        }
        else lastDate = y.date
      })
      //@ts-ignore
      return acc.concat(yos)
    },[] as Array<{glider:string,idx:number,date:Date,isUnderWater:boolean,cycle:number}>).sort((a,b) => a.date.getTime() - b.date.getTime())
  )  
  

  function goPrevYo(val:number){
      let yo = null                
      let offset = 1
      while(val-offset >= 0 && (yo = allYos.value[val-offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater)  changeValue(val - offset)
  }

  function goNextYo(val:number){
      let yo = null              
      let offset = 1
      while(allYos.value.length > (val+offset) &&  (yo = allYos.value[val+offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater) changeValue(val + offset)
  }

  

  watch(timelineIndex, (newIndex:number) => {
    checkIndex(newIndex)
  })

  watch(gliderTimelineIndex, (newIndexes:Array<number>,oldIndexes:Array<number>) => {
    if(canUpdateYoIndex.value){      
      //recherche le premier index qui a changé
      let newIndex = newIndexes.findIndex((newIndex,idx) => newIndex != oldIndexes[idx])
      const gliderToFind = gliderKeys.value[newIndex]
      const indexToFind = newIndexes[newIndex]

      const newYos = allYos.value.findIndex(yo => yo.glider == gliderToFind && yo.idx == indexToFind)
      changeValue(newYos)
    }
  })

  watch(isPlaying, (playing:boolean) => {
    if(playing) {  
      //si on reviens au debut on attend que l'animation du curseur de la time line soit fini avant de lancer le play                      
      if(currentValue.value == allYos.value.length - 1) {
        changeValue(0)
        setTimeout(() => play(),350)          
      } 
      else  {                     
        play()
      }
    }      
  })

  function play() {
      if(isPlaying.value) {
        if(currentValue.value == allYos.value.length - 1) {
          isPlaying.value = false
        }
        else{
          changeValue(currentValue.value+1)            
          setTimeout(() => play(),350)
        }     
      }
  }


  
  function checkIndex(newIndex:number) {
    canUpdateYoIndex.value = false
    currentValue.value = newIndex != -1? newIndex : allYos.value.length-1
    //Met à jour la position de chaque glider de la simulation à l'index le plus proche
    gliderKeys.value.forEach(glider => {
      //recherche de l'index le plus proche pour chaque glider   
      let searchIndex = currentValue.value
      let searchYo = null
      while(searchIndex >= 0 &&  (searchYo = allYos.value[searchIndex]).glider != glider) {
        searchIndex--;
      }         
      const coverageIterationMissionUiStateId = buildCoverageIterationMissionUiStateId(props.uiid,glider)
      store.myGetters.coverageIterationMissionUiStateByUiid(coverageIterationMissionUiStateId).timelineIndex = searchYo?.glider == glider?searchYo.idx:0      
      
    })
    setTimeout(() => canUpdateYoIndex.value = true,100)
  }
  



return { __sfc: true,isPlaying, _currentValue, currentValue, props, coverageIterationState, gliderKeys, timelineIndex, gliderTimelineIndex, currentDate, canUpdateYoIndex, changeValue, allYos, goPrevYo, goNextYo, play, checkIndex }
}

})